export default __webpack_public_path__ + "static/media/commander_xp_2.63c31c93.png";